import { useState, useEffect } from 'react';
import { BeatLoader } from 'react-spinners';
import { Loading } from './styles';

function LoadingPage(): JSX.Element {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      document.body.style.cssText = `overflow: hidden;`;
    }, 50);
    return () => {
      setTimeout(() => {
        document.body.style.cssText = ``;
      }, 50);
    };
  }, []);

  return (
    <Loading>
      <BeatLoader
        color="#333333"
        size={isMobile ? 10 : 11}
        margin={isMobile ? 8 : 10}
      />
    </Loading>
  );
}

export default LoadingPage;
